import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const FILTERS = [
  { slug: "all", label: "Everything" },
  { slug: "carpets", label: "Carpets" },
  { slug: "rugs", label: "Rugs" },
  { slug: "photo-frames", label: "Photo Frames" },
  { slug: "kids-baskets", label: "Kids Baskets" },
];

export default function Collections() {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const cat = params.get("cat") || "all";

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data.products || []));
  }, []);

  const filtered = useMemo(() => {
    if (cat === "all") return products;
    return products.filter((p) => p.category === cat);
  }, [products, cat]);

  return (
    <div data-testid="collections-page">
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-10">
        <div className="overline">The Collection</div>
        <h1 className="mt-4 font-serif text-5xl md:text-6xl lg:text-7xl font-light text-[#1B3B36] leading-[1.02] tracking-tight max-w-4xl">
          Small collections. <em className="italic text-[#84968C]">Enormous care.</em>
        </h1>
        <p className="mt-8 text-[16px] leading-relaxed text-[#4A4A4A] font-light max-w-2xl">
          Every season we release a handful of pieces — never more than the atelier
          can finish without hurry. Filter below to see what is with us right now.
        </p>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 border-t border-[#D8D4CC] py-8 sticky top-20 md:top-24 bg-[#F9F8F6]/85 backdrop-blur-xl z-30">
        <div className="flex flex-wrap gap-3">
          {FILTERS.map((f) => (
            <button
              key={f.slug}
              data-testid={`filter-${f.slug}`}
              onClick={() =>
                setParams(f.slug === "all" ? {} : { cat: f.slug })
              }
              className={`px-5 py-2 text-[12px] uppercase tracking-[0.18em] transition-colors border ${
                cat === f.slug
                  ? "bg-[#1B3B36] text-[#F9F8F6] border-[#1B3B36]"
                  : "bg-transparent text-[#1B3B36] border-[#D8D4CC] hover:border-[#1B3B36]"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-14 md:py-20">
        {filtered.length === 0 ? (
          <div className="py-24 text-center text-[#4A4A4A]">
            <div className="font-serif text-3xl text-[#1B3B36]">
              Nothing here — yet.
            </div>
            <p className="mt-4 max-w-md mx-auto font-light">
              This collection is currently being woven. Please check back soon,
              or commission a piece from our Custom Studio.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {filtered.map((p) => (
              <ProductCard key={p.id} product={p} testIdPrefix="collections" />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
